module.exports = __webpack_public_path__ + "img/product.2075b37c.png";